import * as React from "react";
function BagHoldIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 9.25H9a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5m.75 3.75a.76.76 0 0 0-.75-.75H9a.75.75 0 0 0 0 1.5h6a.76.76 0 0 0 .75-.75m0 4.5a.76.76 0 0 0-.75-.75H9a.75.75 0 0 0 0 1.5h6a.76.76 0 0 0 .75-.75m4-12v15a2.25 2.25 0 0 1-2.25 2.25h-1.75v.5a.75.75 0 0 1-1.5 0v-.5h-4.5v.5a.75.75 0 0 1-1.5 0v-.5H6.5a2.25 2.25 0 0 1-2.25-2.25v-15A2.25 2.25 0 0 1 6.5 3.25h1.75v-2C8.25.56 8.81 0 9.5 0h5c.69 0 1.25.56 1.25 1.25v2h1.75a2.25 2.25 0 0 1 2.25 2.25m-10-2.25h4.5V1.5h-4.5zm8.5 2.25a.76.76 0 0 0-.75-.75h-11a.76.76 0 0 0-.75.75v15a.76.76 0 0 0 .75.75h11a.76.76 0 0 0 .75-.75z"
  }));
}
export default BagHoldIcon;